import { postRequest } from "components/Common/Utils";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";

const SettingManage = () => {
    const [data, setData] = useState([]);
    const [deliveryCharges, setDeliveryCharges] = useState({
        distance: {
            baseKm: 0,
            chargeBaseKm: 0,
            chargePerKm: 0,
        },
        weight: {
            baseKg: 0,
            chargeBaseKg: 0,
            chargePerKg: 0,
        },
    });
    const [warAmount, setWarAmount] = useState('');
    const fetchPaymentSetting = async () => {
        try {
            const response = await postRequest('setting/get-setting');
            if (response?.status) {
                const resp = response?.data?.adminSetting;
                const paymentMethod = response?.data?.paymentMethods;
                setDeliveryCharges(resp?.deliveryCharges);
                console.log(resp);
                setData(resp);
            }
        }
        catch (error) {
            console.log('please contact to kulies')
        }
    }

    useEffect(() => {
        fetchPaymentSetting();
    }, []);

    ///Update DeliveryCharges
    const handleChange = (e, category, field) => {
        const value = parseFloat(e.target.value) || 0;
        setDeliveryCharges((prev) => ({
            ...prev,
            [category]: {
                ...prev[category],
                [field]: value,
            },
        }));
    };

    // Add a new bank detail
    const addBankDetail = () => {
        setData((prevState) => ({
            ...prevState,
            paymentMethods: {
                ...prevState.paymentMethods,
                bankDeposit: {
                    ...prevState.paymentMethods.bankDeposit,
                    bankDetails: [
                        ...prevState.paymentMethods.bankDeposit.bankDetails,
                        {
                            bankName: "",
                            accountNumber: "",
                            ifscCode: "",
                            instructions: "",
                        },
                    ],
                },
            },
        }));
    };

    const handleUpdate = (key, value, path) => {
        const newData = { ...data };
        let current = newData;

        path.forEach((p, index) => {
            if (index === path.length - 1) {
                current[p] = value; // Update the value at the specified path
            } else {
                current[p] = { ...current[p] }; // Ensure immutability for nested objects
                current = current[p];
            }
        });

        setData(newData);
    };

    // Update a bank detail field
    const updateBankDetail = (index, key, value) => {
        const updatedBankDetails = [...data?.paymentMethods.bankDeposit.bankDetails];
        updatedBankDetails[index][key] = value;
        setData((prevState) => ({
            ...prevState,
            paymentMethods: {
                ...prevState.paymentMethods,
                bankDeposit: {
                    ...prevState.paymentMethods.bankDeposit,
                    bankDetails: updatedBankDetails,
                },
            },
        }));
    };

    // Remove a bank detail
    const removeBankDetail = (index) => {
        const updatedBankDetails = data?.paymentMethods.bankDeposit.bankDetails.filter(
            (_, i) => i !== index
        );
        setData((prevState) => ({
            ...prevState,
            paymentMethods: {
                ...prevState.paymentMethods,
                bankDeposit: {
                    ...prevState.paymentMethods.bankDeposit,
                    bankDetails: updatedBankDetails,
                },
            },
        }));
    };

    // Add a new delivery charge
    // const addDeliveryCharge = () => {
    //     setData((prevState) => ({
    //         ...prevState,
    //         deliveryCharges: [
    //             ...prevState.deliveryCharges,
    //             { from: 0, to: 0, baseCharge: 0 }, // Default new delivery charge
    //         ],
    //     }));
    // };

    // Update a delivery charge field
    // const updateDeliveryCharge = (index, key, value) => {
    //     const updatedDeliveryCharges = [...data?.deliveryCharges];
    //     updatedDeliveryCharges[index][key] = value;
    //     setData((prevState) => ({
    //         ...prevState,
    //         deliveryCharges: updatedDeliveryCharges,
    //     }));
    // };

    // // Remove a delivery charge
    // const removeDeliveryCharge = (index) => {
    //     const updatedDeliveryCharges = data?.deliveryCharges.filter((_, i) => i !== index);
    //     setData((prevState) => ({
    //         ...prevState,
    //         deliveryCharges: updatedDeliveryCharges,
    //     }));
    // };

    const handleSubmit = async () => {
        // console.log(data);
        let payload = data
        payload.deliveryCharges = deliveryCharges;
        try {
            const response = await postRequest('setting/update-setting', data);
            if (response?.status) {
                // const resp = response?.data;
                // setData(resp);
                Swal.fire({
                    icon: "success",
                    title: "Successfully!",
                    text: response?.message,
                    // timer: 1500,
                    showConfirmButton: true,
                });
            }
        }
        catch (error) {
            console.log('please contact to kulies')
        }
    };

    return (
        // <></>
        <div className="setting-page">
            <div className="col-md-6">
                <div className="page-title-box">
                    <h4>Setting Management</h4>

                    <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item active">Setting Management</li>:{" "}
                        <li className="breadcrumb-item">Admin Setting</li>
                    </ol>
                </div>
            </div>
            <div className="col-md-6 text-end">
            </div>

            <div className="card">
                <div className="card-body">

                    {Object.entries(data?.paymentMethods || {}).map(([key, method]) => (
                        <div key={key}>
                            <div className="flex-header-setting">
                                <h2>{key}</h2>
                            </div>
                            <div className="flex-body">
                                <label>

                                    <input
                                        type="checkbox"
                                        checked={method.isActive}
                                        onChange={(e) =>
                                            handleUpdate(key, e.target.checked, ["paymentMethods", key, "isActive"])
                                        }
                                    />
                                    <span className="left-34"> Is Active:</span>
                                </label>
                                <br />
                                <div className="row">
                                    <div className="col-lg-3">
                                        <label>
                                            Min Limit:
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={method.transactionLimit.minLimit}
                                                onChange={(e) =>
                                                    handleUpdate(
                                                        "minLimit",
                                                        parseInt(e.target.value),
                                                        ["paymentMethods", key, "transactionLimit", "minLimit"]
                                                    )
                                                }
                                            />
                                        </label>
                                    </div>
                                    <div className="col-lg-3">
                                        <label>
                                            Max Limit:
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={method.transactionLimit.maxLimit}
                                                onChange={(e) =>
                                                    handleUpdate(
                                                        "maxLimit",
                                                        parseInt(e.target.value),
                                                        ["paymentMethods", key, "transactionLimit", "maxLimit"]
                                                    )
                                                }
                                            />
                                        </label>
                                    </div>

                                    {key === "payNow" && (
                                        <div className="col-lg-3">
                                            <label>
                                                PayNow Charges (In %)
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={method.payNowCharges || 0}
                                                    onChange={(e) => {
                                                        let value = parseInt(e.target.value);
                                                        if (isNaN(value)) value = 0;
                                                        value = Math.max(0, Math.min(100, value)); // Restrict between 0-100
                                                        handleUpdate("payNowCharges", value, ["paymentMethods", key, "payNowCharges"]);
                                                    }}
                                                />
                                            </label>
                                        </div>
                                    )}

                                    {key === "bankDeposit" && (
                                        <div className="col-lg-3">
                                            <label>
                                                Bank Deposit Charges (In %)
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={method.bankDepositCharges || 0}
                                                    onChange={(e) => {
                                                        let value = parseInt(e.target.value);
                                                        if (isNaN(value)) value = 0;
                                                        value = Math.max(0, Math.min(100, value)); // Restrict between 0-100
                                                        handleUpdate("bankDepositCharges", value, ["paymentMethods", key, "bankDepositCharges"]);
                                                    }}
                                                />
                                            </label>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    ))}

                    <div className="flex-header-setting">
                        <h2>Bank Details</h2>
                        <button className="btn " onClick={addBankDetail}>Add Bank Detail</button>
                    </div>
                    <div className="flex-body">
                        {data?.paymentMethods?.bankDeposit?.bankDetails?.map((detail, index) => (
                            <div className="row align-items-center" key={index}>
                                <div className="col-lg-3">
                                    <label>
                                        Bank Name:
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={detail.bankName}
                                            onChange={(e) =>
                                                updateBankDetail(index, "bankName", e.target.value)
                                            }
                                        />
                                    </label>
                                </div>
                                <div className="col-lg-3">
                                    <label>
                                        Account Number:
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={detail.accountNumber}
                                            onChange={(e) =>
                                                updateBankDetail(index, "accountNumber", e.target.value)
                                            }
                                        />
                                    </label>
                                </div>
                                <div className="col-lg-3">
                                    <label>
                                        IFSC Code:
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={detail.ifscCode}
                                            onChange={(e) =>
                                                updateBankDetail(index, "ifscCode", e.target.value)
                                            }
                                        />
                                    </label>
                                </div>
                                <div className="col-lg-5">
                                    <label>
                                        Instructions:
                                        <textarea
                                            style={{ height: '35px' }}
                                            className="form-control"
                                            value={detail.instructions}
                                            onChange={(e) =>
                                                updateBankDetail(index, "instructions", e.target.value)
                                            }
                                        />
                                    </label>
                                </div>
                                <div className="col-lg-5">
                                    <button className="btn text-danger mt-2" onClick={() => removeBankDetail(index)}>Remove</button>
                                </div>
                                <hr />
                            </div>
                        ))}
                    </div>

                    <div className="flex-header-setting">
                        <h2>Delivery Fee Management
                        </h2>
                    </div>
                    <div className="flex-body">
                        <div className="row mb-4">
                            <h4>Distance-Based Charges: </h4>
                            <div className="col-lg-3">
                                <label>Base Distance (Km):</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={deliveryCharges.distance.baseKm}
                                    onChange={(e) => handleChange(e, "distance", "baseKm")}
                                />
                            </div>
                            <div className="col-lg-3">
                                <label>Charge for Base Distance ($):</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={deliveryCharges.distance.chargeBaseKm}
                                    onChange={(e) => handleChange(e, "distance", "chargeBaseKm")}
                                />
                            </div>
                            <div className="col-lg-3">
                                <label>Beyond Base Distance ($):</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={deliveryCharges.distance.chargePerKm}
                                    onChange={(e) => handleChange(e, "distance", "chargePerKm")}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <h4>Weight-Based Charges:</h4>
                            <div className="col-lg-3">
                                <label>Base Weight (Kg):
                                </label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={deliveryCharges.weight.baseKg}
                                    onChange={(e) => handleChange(e, "weight", "baseKg")}
                                />
                            </div>
                            <div className="col-lg-3">
                                <label>Charge for Base Weight ($):
                                </label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={deliveryCharges.weight.chargeBaseKg}
                                    onChange={(e) => handleChange(e, "weight", "chargeBaseKg")}
                                />
                            </div>
                            <div className="col-lg-3">
                                <label>Charge per Kg ($):
                                </label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={deliveryCharges.weight.chargePerKg}
                                    onChange={(e) => handleChange(e, "weight", "chargePerKg")}
                                />
                            </div>
                        </div>
                    </div>

                    {/* <div className="flex-header-setting">
                        <h2>Delivery Charges</h2>
                        <button className="btn" onClick={addDeliveryCharge}>Add Delivery Charge</button>
                    </div>
                    <div className="flex-body">
                        {data?.deliveryCharges?.map((charge, index) => (
                            <div className="row align-items-center" key={index}>
                                <div className="col-lg-3">
                                    <label>
                                        From:
                                        <input
                                            className="form-control"
                                            type="number"
                                            value={charge.from}
                                            onChange={(e) =>
                                                updateDeliveryCharge(index, "from", parseInt(e.target.value))
                                            }
                                        />
                                    </label>
                                </div>
                                <div className="col-lg-3">
                                    <label>
                                        To:
                                        <input
                                            className="form-control"
                                            type="number"
                                            value={charge.to}
                                            onChange={(e) =>
                                                updateDeliveryCharge(index, "to", parseInt(e.target.value))
                                            }
                                        />
                                    </label>
                                </div>
                                <div className="col-lg-3">
                                    <label>
                                        Base Charge:
                                        <input
                                            className="form-control"
                                            type="number"
                                            value={charge.baseCharge}
                                            onChange={(e) =>
                                                updateDeliveryCharge(
                                                    index,
                                                    "baseCharge",
                                                    parseInt(e.target.value)
                                                )
                                            }
                                        />
                                    </label>
                                </div>
                                <div className="col-lg-3">
                                    <button className="btn text-danger mt-2" onClick={() => removeDeliveryCharge(index)}>Remove</button>
                                </div>
                            </div>
                        ))}
                    </div> */}

                    <div className="flex-header-setting">
                        <h2>Delivery Commission</h2>

                    </div>

                    <div className="flex-body">
                        <div className="col-lg-3">
                            <label> Admin Delivery Commission (In %)  </label>
                            <input
                                type="number"
                                className="form-control"
                                name="deliveryCommission"
                                value={data?.deliveryCommission}
                                onChange={(e) => {
                                    const value = parseFloat(e.target.value);
                                    if (value >= 101) {
                                        setWarAmount("The delivery commission cannot be 100% or higher.");
                                        return;
                                    } else {
                                        setWarAmount(''); // Hide the message when the value is valid
                                    }
                                    handleUpdate("deliveryCommission", value, ["deliveryCommission"]);
                                }}
                            />{warAmount &&
                                <small className="text-danger">{warAmount}</small>}
                        </div>
                    </div>
                

                    <div className="flex-header-setting">
                        <h2>Delivery Agent Payout</h2>
                    </div>

                    <div className="flex-body">
                        <div className="col-lg-3">
                            <label>Agent Credit Days</label>
                            <input
                                type="number"
                                className="form-control"
                                name="deliveryCreditDays"
                                value={data?.deliveryCreditDays}
                                onChange={(e) => {
                                const value = parseFloat(e.target.value);
                                  handleUpdate("deliveryCreditDays", value, ["deliveryCreditDays"]);
                                }}
                            />
                        </div>
                    </div>

                    <div className="d-flex justify-content-end" style={{ gap: '10px' }}>
                        <button type="button" className="btn btn-primary ml-2" onClick={handleSubmit}>Save</button>
                        <button type="reset" className="btn btn-danger mr-2">Reset</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingManage;
